import { useQuery } from "@tanstack/react-query";

import { getUser, getUserPreferences } from "api/methods";

export const useUser = () => {
  const query = useQuery({
    ...getUser.keyed(),
    retry: false,
    staleTime: 1000 * 60 * 2,
  });

  return {
    user: query.data,
    isLoading: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export const useUserPreferences = () => {
  const { data } = useQuery({
    ...getUserPreferences.keyed(),
    staleTime: 1000 * 60 * 2,
  });

  return { preferences: data };
};
